import { TweenMax } from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";
// import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js";

import APNG from "../../plugins/apng-canvas.js";
import isMobile from "../../plugins/is-mobile.js";

var controller = new ScrollMagic.Controller();

// window.APNG.ifNeeded().then(function () {
//   var images = document.querySelectorAll(".apng-image");
//   for (var i = 0; i < images.length; i++) {
//     window.APNG.animateImage(images[i]);
//   }
// });

const targetURL = "/assets/img/grand-top/logo-animation.png";

window.APNG.parseURL(targetURL).then((apng) => {
  const canvas = document.createElement("canvas");
  canvas.width = apng.width;
  canvas.height = apng.height;
  document.getElementById("apng-image").appendChild(canvas);

  apng.addContext(canvas.getContext("2d"));
  apng.rewind();
  // apng.play();

  let concept = new ScrollMagic.Scene({
    triggerElement: ".js-concept-area",
    triggerHook: "onLeave",
    offset: -400,
  })
    // .addIndicators()
    .addTo(controller);

  concept.on("enter", () => {
    apng.play();
    setTimeout(() => {
      TweenMax.to($(".js-concept-line"), 1.5, {
        y: 0,
        force3D: true,
        ease: Quint.easeOut,
      });
    }, 1200);
  });
});
